import { Component } from 'react'

class Logout extends Component {

    logout() {
        localStorage.removeItem("jwtToken");
    }

    componentDidMount() {
        this.props.history.push("/");
        window.location.reload();
    }

    render() {
        this.logout();
        return null;
    }

}

export default Logout;